module.exports = __webpack_public_path__ + "img/viggo.a70859d9.jpg";